import {css} from 'lit';
export const styles = css`:host {
  display: block;
}

header {
  margin-bottom: 0.4em;
}

.title {
  color: var(--gray-700);
  font-weight: bold;
}

.subtitle {
  color: var(--gray-600);
}

:host(:not([grid])) ef-grid-list {
    flex-wrap: nowrap;
  }
`;
export default styles;
